import Vue from 'vue';
import Vuex from 'vuex';

// 告诉 Vue 使用 Vuex store
Vue.use(Vuex);

// 创建 store 实例
const store = new Vuex.Store({
  state: {
    actvieNum:1
    // 状态
  },
  mutations: {
    // 同步函数，改变状态
    actvieNumAdd(state, amount) {
      state.actvieNum = amount;
    }
  },
  actions: {
    // 异步操作
  },
  getters: {
    actvieNum:(state)=>{
      return state.actvieNum
    },
    // 从状态派生的状态
  },
  modules: {
    // 模块化store
  }
});

export default store;